export default __webpack_public_path__ + "static/media/UV-Protective_Face_Shield.02c02fc1.svg";